module.exports = __webpack_public_path__ + "111ecd446b6850fb9464ae8cd5ce0f5e.png";